export default {
  name: 'Link Tracker',
  description: 'Track clicks and visitors for custom domain links',
  icon: 'link-outline',
  enabled: true
};